<template>
    <span class="text-nowrap">
        <template>
            <router-link :to="{'name': 'pharmacy-prescription-detail', 'params': {'id': prescriptionId}}">{{statusId === 100? 'Update Prescription': 'View Prescription'}}</router-link>
        </template>
    </span>
</template>

<script>
export default {
    'name': 'PharmacyPrescriptionAction',
    'props': {
        'statusId': {
            'required': true
        },
        'prescriptionId': {
            'required': true
        }
    }
};
</script>

<style>

</style>
